// extracted by mini-css-extract-plugin
module.exports = {"container":"MbapiAdminTopBarRightComponent_container__2VFs5"};